import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import SingleCardImageBottom from "@qlik/qlik/src/components/Card/Single-Card-Image-Bottom";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
/**
 * @param {Object} props - The props for the DeckImageCards component.
 * @returns {JSX.Element} - The DeckImageCards component.
 */

const DeckCardWithBottomImage = ({ data }) => {
    const { cardItems, title, additionalConfiguration, backgroundColor, numberOfColumns, customId } = data ?? {};

    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const titleColor = sectionColorMapping.primaryTextColor;
    const spacingClassNames = getSpacingClassName(additionalConfiguration, "lg:py-30");
    const cardGridClassName = title ? "mt-15 lg:mt-20" : "";
    return (
        <section
            data-section
            className={` py-7.5 scroll-mt-45 ${spacingClassNames} ${sectionColorMapping.bgColor}`}
            id={customId}
        >
            <div className="container">
                {title && <h2 className={`text-center lg:text-6xl ${titleColor}`}>{title}</h2>}
                <div
                    className={`grid gap-9.5   lg:gap-15  lg:gap-y-14.75 ${
                        numberOfColumns === null ? "md:grid-cols-2" : `md:grid-cols-${numberOfColumns}`
                    }  ${cardGridClassName}`}
                >
                    {cardItems?.map((card) => (
                        <SingleCardImageBottom data={card} key={card.id} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DeckCardWithBottomImage;
